import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'semantic-ui-react';
import {
  defaultVideoOperationV1016,
  normalizeVideoProtocolV1016,
  supportsVideoProtocolV1016,
  videoProtocolOptionsV1016,
  OPENLUX_OPERATIONS_V1018,
} from './videoProtocolV1016';

export default function VideoProtocolControlV1016({
  channelType,
  value,
  operation,
  onChange,
}) {
  const { t, i18n } = useTranslation();
  const id = useId();
  if (!supportsVideoProtocolV1016(channelType)) return null;

  const options = videoProtocolOptionsV1016(channelType, t);
  let selected = '';
  let invalid = false;
  try {
    selected = normalizeVideoProtocolV1016(value);
    invalid = !options.some((option) => option.value === selected);
  } catch {
    invalid = true;
  }
  const label = t('channel.edit.video_v1016.protocol', 'Video protocol');
  return (
    <>
    <Form.Dropdown
      id={`video-protocol-v1016-${id}`}
      name='video_protocol_v1016'
      label={label}
      aria-label={label}
      fluid
      selection
      options={options}
      value={invalid ? '__unsupported_video_protocol_v1016__' : selected}
      text={
        invalid
          ? t('channel.edit.video_v1016.invalid_value', 'Unsupported protocol')
          : selected === '' ? options[0].text : undefined
      }
      error={
        invalid
          ? t(
              'channel.edit.video_v1016.invalid',
              'Select a supported video protocol.'
            )
          : false
      }
      onChange={(_, { value: protocol }) => {
        if (
          !options.some(
            (option) => option.value === protocol && !option.disabled
          )
        )
          return;
        onChange({
          video_protocol_v1016: protocol,
          video_operation_v1016:
            !invalid &&
            protocol &&
            protocol !== 'legacy' &&
            protocol === selected
              ? operation ?? ''
              : defaultVideoOperationV1016(protocol),
        });
      }}
    />
    {selected === 'openlux' && !invalid && <Form.Select
      label={i18n?.language?.startsWith('zh') ? 'OpenLux 媒体操作' : 'OpenLux media operation'}
      aria-label='OpenLux operation' name='video_operation_v1016'
      selection fluid value={operation || ''}
      options={OPENLUX_OPERATIONS_V1018.map(value => ({ key: value, value, text: value }))}
      error={operation && !OPENLUX_OPERATIONS_V1018.includes(operation) ? true : false}
      onChange={(_, { value: nextOperation }) => onChange({
        video_protocol_v1016: 'openlux', video_operation_v1016: nextOperation,
      })} />}
    </>
  );
}
